import React, { useState, useEffect } from 'react';
import noData from '@/assets/noData.png';
import "./index.scss";

function noDataPage(props: any) {
    const { display } = props;
    
    return (
        <div className='noDataPage' style={{ display }} >
            <div className='box'>
                <img src={noData} />
                <span>暂无数据~</span>
            </div>
        </div>
    );
}

export default noDataPage;
